import { CreateCashBookDto, UpdateCashBookDto } from "@/modules/finances/cashbooks/types"
import { formatterInputNumber } from "@/utils/helpers"
import { DatePicker, Form, Input, InputNumber, Modal } from "antd"
import dayjs from "dayjs"
import React, { useEffect } from "react"

interface UpsertFormProps {
  visible: boolean
  mode: 'create' | 'update'
  initialData?: any // Dữ liệu ban đầu khi sửa
  onCancel: () => void
  onSubmit: (data: CreateCashBookDto | UpdateCashBookDto) => Promise<void>
  loading?: boolean
}

const UpsertForm: React.FC<UpsertFormProps> = ({
  visible,
  mode,
  initialData,
  onCancel,
  onSubmit,
  loading = false
}) => {
  const [form] = Form.useForm()

  // Set initial values khi sửa
  useEffect(() => {
    if (visible && mode === 'update' && initialData) {
      form.setFieldsValue({
        name: initialData.name,
        date_range: [
          dayjs(initialData.from_date),
          dayjs(initialData.to_date)
        ],
        opening_balance: initialData.opening_balance
      })
    }
  }, [visible, mode, initialData, form])

  const handleSubmit = async (values: any) => {
    try {
      const [from, to] = values.date_range || [];
      const data = {
        name: values.name,
        from_date: from ? dayjs(from).format('YYYY-MM-DD HH:mm') : '',
        to_date: to ? dayjs(to).format('YYYY-MM-DD HH:mm') : '',
        opening_balance: Number(values.opening_balance)
      }
      await onSubmit(data)
      form.resetFields()
    } catch (error) {
      // Error handling is done in parent component
    }
  }

  const handleCancel = () => {
    form.resetFields()
    onCancel()
  }

  return (
    <Modal
      title={mode === 'create' ? "Tạo sổ quỹ mới" : "Cập nhật sổ quỹ"}
      open={visible}
      onCancel={handleCancel}
      onOk={() => form.submit()}
      confirmLoading={loading}
      okText={mode === 'create' ? "Tạo sổ quỹ" : "Cập nhật"}
      cancelText="Hủy"
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
      >
        <Form.Item
          label="Tên sổ quỹ"
          name="name"
          rules={[{ required: true, message: 'Vui lòng nhập tên sổ quỹ!' }]}
        >
          <Input
            placeholder="Nhập tên sổ quỹ"
          />
        </Form.Item>
        <Form.Item
          label="Khoảng thời gian"
          name="date_range"
          rules={[{ required: true, message: 'Vui lòng chọn khoảng thời gian!' }]}
        >
          <DatePicker.RangePicker
            style={{ width: '100%' }}
            format="DD/MM/YYYY HH:mm"
            showTime={{ format: 'HH:mm' }}
            placeholder={["Từ ngày", "Đến ngày"]}
          />
        </Form.Item>
        <Form.Item
          label="Số dư đầu kỳ"
          name="opening_balance"
          rules={[{ required: true, message: 'Vui lòng nhập số dư đầu kỳ!' }]}
        >
          <InputNumber
            style={{ width: '100%' }}
            placeholder="Nhập số dư đầu kỳ"
            min={0}
            formatter={value => formatterInputNumber(value)}
            addonAfter="VNĐ"
            step={10000}
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default UpsertForm 